import classNames from "classnames";
import ObjectPreview from "./Object";
import { ImageRelevance } from "types";
import useHoverDelay from "helpers/utility/utilities";
import RelevanceIcon from "views/uikit/RelevanceIcon";
import ScrollAwareHover from "views/components/ScrollAwareHover";

import styles from "./style.module.scss";
import ImageWithFallback from "../../../components/ImageWithFallback";

const ImagePreview = ({
  src,
  labels,
  hoverDelay,
  boundingBoxes,
  showAssetPreview,
  relevance,
  onUpdateAssetData,
  timestamp,
}: PreviewCardProps) => {
  const imageWrapperClassNames = classNames(styles.imageWrapper, {
    [styles.imageWrapperForAssetPreview]: showAssetPreview,
  });

  const { handleMouseEnter, handleMouseLeave } = useHoverDelay(
    onUpdateAssetData,
    hoverDelay,
  );

  return boundingBoxes.length > 0 ? (
    <ObjectPreview
      src={src}
      labels={labels}
      boundingBoxes={boundingBoxes}
      relevance={relevance}
      showAssetPreview={showAssetPreview}
      handleMouseEnter={handleMouseEnter}
      handleMouseLeave={handleMouseLeave}
      timestamp={timestamp}
    />
  ) : (
    <ScrollAwareHover
      className={imageWrapperClassNames}
      onMouseOver={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <>
        {relevance && <RelevanceIcon relevance={relevance} />}
        <ImageWithFallback
          thumbImage={{ src }}
          plainImage={{ src }}
          alt="single img"
          data-testid="single-image"
          className={styles.plainImage}
        />
      </>
    </ScrollAwareHover>
  );
};

export default ImagePreview;

interface PreviewCardProps {
  src: string;
  labels: string[];
  hoverDelay: number;
  showAssetPreview: boolean;
  boundingBoxes: number[][];
  relevance?: ImageRelevance;
  onUpdateAssetData: () => void;
  timestamp?: number;
}
